import React from 'react';
import Header from './Header';
import ParticleBackground from '../UI/ParticleBackground';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <ParticleBackground />
      <Header />
      <main className="relative z-10">
        {children}
      </main>
    </div>
  );
};

export default Layout;
